import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material'
import { PaperArrastavel } from '../../../dialog-arrastavel/PaperArrastavel'
import { isSistemaOperacionalWindows } from 'app/utils/isSistemaOperacionalWindows'
import clsx from 'clsx'
import React, { useContext, useState } from 'react'
import { PaginaPesquisaProdutoContext } from '../../pagina-pesquisa-produto/PaginaPesquisaProduto'
import { ordenarColunas, traduzirOrdenarNomeColunaPesquisaProduto } from '../TraduzirOrdenarNomeColunaPesquisaProduto'
const estilosGridItens = require('../../../itens-orcamento/grid-itens/grid-itens.module.scss').default
const estilosTableHead = require('../../../itens-orcamento/grid-itens/head/tableHead.module.scss').default
const tipografia = require("../../../estilos-reutilizaveis/tipografia.module.scss").default;

export const AcoesHeadGridItens = () => {
    const contexto = useContext(PaginaPesquisaProdutoContext)
    //const exibirColunaQuantidade = contexto.chamadoParaInserirProdutoNoOrcamento && !contexto.pesquisandoApenasParaFiltroProdutosLupa
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')

    const ocultarColunas: { [key: string]: boolean } = {
        "% Markup": !contexto.exibirColunaMarkup,
        "Estoque CD": !contexto.exibirEstoqueOutrasFiliais,
        "Estoque Outras Filiais": !contexto.exibirEstoqueOutrasFiliais,
        "Estoque Total": !contexto.exibirEstoqueTotal,
       // Quantidade: !exibirColunaQuantidade, // Cabeçalho da coluna Quantidade removido (itemPesquisaProduto_ColunaQuant)
        "Desconto Máximo": !contexto.utilizaDescontoMaximoBonificacaoAvancados,
        Bonificação: !contexto.utilizaDescontoMaximoBonificacaoAvancados,
        "Última Compra": !contexto.exibirColunaMarkup,
        Comprador: !contexto.exibirColunaMarkup,
        "Local Físico": !(!contexto.exibirColunaMarkup && contexto.exibirLocalFisico),
        "Preço à Vista": !contexto.exibirPrecoAVista,
        "PrecoUnitarioAVista": !contexto.exibirPrecoAVista,
        Ações: true,
    };
    const colunasOcultas = (nomeColuna: string) =>
        ocultarColunas[nomeColuna] == undefined
            ? false
            : ocultarColunas[nomeColuna];

    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)

    const selecaoDeColunas = <div className="_grid _grid-cols-1 _grid-flow-row">

        <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
            <div className="_mr-4">
                <input
                    type="checkbox"
                    id={`AcoesHeadGridItens_checkbox_SelecionarTodasColunas`}
                    key={`AcoesHeadGridItens.tsx_checkbox_SelecionarTodasColunas`}
                    checked={contexto.colunas.every(c => c.Selecionada == true)}
                    onChange={e => contexto.onToggleSelecionarTodasColunas(e.target.checked)} />
            </div>

            <b>Todas</b>

        </div>

        {ordenarColunas(contexto.colunas).filter(c => !colunasOcultas(traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: c.Nome, nomeGrid: "PESQUISAR_PRODUTOS_ORCAMENTO" }))).

            map(coluna => <div
                className="_flex _flex-row _justify-start _max-w-xs _items-end"
                id={`AcoesHeadGridItens_div_${coluna.Nome}`}
                key={coluna.Nome}>

                <div className="_mr-4">
                    <input
                        type="checkbox"
                        id={`AcoesHeadGridItens_checkbox_${coluna.Nome}`}
                        key={`AcoesHeadGridItens.tsx_checkbox_${coluna.Nome}`}
                        checked={coluna.Selecionada ?? false}
                        onChange={() => contexto.onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)} />
                </div>

                {traduzirOrdenarNomeColunaPesquisaProduto({ nomeColuna: coluna.Nome, nomeGrid: "PESQUISAR_PRODUTOS_ORCAMENTO", nomeAcoesGrid: true })}
            </div>)}
    </div>

    const selecaoDeColunasDialog =
        <Dialog
            open={exibirSelecaoColunas}
            onClose={() => setExibirSelecaoDeColunas(false)}
            id="AcoesHeadGridItens_Dialof"
            PaperComponent={PaperArrastavel}
        >
            <DialogTitle>
                Selecionar colunas para exibição
            </DialogTitle>
            <DialogContent>
                {selecaoDeColunas}
            </DialogContent>
        </Dialog>

    const botoes = <div className={clsx(["_flex _flex-row _gap-x-2", estilosTableHead.acoesHead])}>
        {contexto.obterPermiteEngrenagemGrid &&
            <FontAwesomeIcon
                icon={faGear}
                className="_text-2xl _cursor-pointer"
                onClick={() => setExibirSelecaoDeColunas(true)}
                id="AcoesHeadGridItens_IconeSelecionarColunas"
            />}


        <button
            className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
            onClick={() => contexto.onAlterarFonte?.(contexto.tamanhoFontePadrao + 1)}
            disabled={contexto.tamanhoFontePadrao >= 26}
            id="AcoesHeadGridItens_AumentarFonte"
        >A+
        </button>
        <button

            className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
            onClick={() => contexto.onAlterarFonte?.(contexto.tamanhoFontePadrao - 1)}
            disabled={contexto.tamanhoFontePadrao <= 8}
            id="AcoesHeadGridItens_DiminuirFonte"
        >A-
        </button>
    </div>

    const iconeExibirEsconderOpcoes = (<>
        <button
            style={{ marginLeft: '14px', height: '20px' }}
            id="AcoesHeadGridItens_table-headgrid-itensarrow"
            className="no-global-button"
            onClick={() => {
                setMostrarFerramentas(!mostrarFerramentas);
                setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
            }}
        >
            <Icon
                id="AcoesHeadGridItens_table-headgrid-itensarrowIcone"
            >{icon}</Icon>
        </button>
        {isSistemaOperacionalWindows() &&
        <span className={tipografia.dicaUsuario} style={{ fontWeight: "normal", cursor: "context-menu", position: "absolute", marginLeft: "50px" }}
            id="AcoesHeadGridItens_table-headgrid-aviso"
        >Mantenha a tecla <kbd>SHIFT</kbd> pressionada para rolar na horizontal</span>
        }
    </>
    );

    return <>
        <div className={estilosTableHead.menu}
            id="AcoesHeadGridItens_Div"
        >
            {iconeExibirEsconderOpcoes}
            {mostrarFerramentas && (
                <section>
                    {botoes}
                </section>
            )}
        </div>

        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </>
}
